var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "application-page career" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [_c("Navigation", { attrs: { page: "career" } })],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "9" } }, [
                _c("h1", [_vm._v("Mein Lebenslauf")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "main-content" },
                  [
                    _c("Career", {
                      class: { "loading-blockade": _vm.saving },
                      attrs: {
                        "section-completions": _vm.sectionCompletions,
                        "vita-info": _vm.vitaInfo
                      },
                      on: { input: _vm.save },
                      model: {
                        value: _vm.career,
                        callback: function($$v) {
                          _vm.career = $$v
                        },
                        expression: "career"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }